"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ActionMenuGroup = void 0;
var react_1 = __importDefault(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var Divider_1 = require("../Divider");
var Eyebrow_1 = require("../Eyebrow");
var ActionMenuGroup = function (_a) {
    var children = _a.children, className = _a.className, label = _a.label, props = __rest(_a, ["children", "className", "label"]);
    return (react_1.default.createElement("div", __assign({ className: classnames_1.default('ActionMenuGroup', className) }, props),
        react_1.default.createElement(Divider_1.Divider, { alignContent: "start", el: "div", spacing: label ? 'half' : '1', className: classnames_1.default(label ? 'ActionMenuGroup__label' : 'ActionMenuGroup__divider') }, label ? react_1.default.createElement(Eyebrow_1.Eyebrow, { className: "m-r-1" }, label) : null),
        children));
};
exports.ActionMenuGroup = ActionMenuGroup;
//# sourceMappingURL=ActionMenuGroup.js.map